<template>
    <div :class="container_class">
        <template>
            <label class="vs-input--label" :class="label_class" v-if="label">{{ label }}</label> 
            <v-select 
                :class="input_class" 
                @search="use_cache ? () => null : do_search" 
                @input="updateModel"
                :options="value_options" 
                v-model="value"
                :filterable="use_cache" 
                :multiple="multiple"
                :placeholder="initialising ? 'Loading...' : placeholder"
                :label="label_keys?label_keys[0]:'label'"
                :disabled="disabled"
                :closeOnSelect="close_on_select"
            >
                <template slot="selected-option" scope="option">
                    <template v-for="(lk, i) in label_keys">
                        <span v-if="option[lk]" :key="i">{{ option[lk] }}&nbsp;</span>
                    </template>
                    <template v-if="show_id_in_label && option.id">
                        &nbsp;(ID: {{ option.id }})
                    </template>
                </template>
                <template v-slot:option="option">
                    <template v-for="(lk, i) in label_keys">
                        <span v-if="option[lk]" :key="i">{{ option[lk] }}&nbsp;</span>
                    </template>
                    <template v-if="show_id_in_label && option.id">
                        &nbsp;(ID: {{ option.id }})
                    </template>
                </template>
            </v-select>
            <div v-if="warning" class="text-danger mt-2 mb-3">
                <small>{{ warning_text }}</small>
            </div>
        </template>
    </div>
</template>

<script>
import vSelect from 'vue-select';
import { Request } from "../../../utils/requests"
import md5 from 'md5'
import moment from 'moment'

export default {
    props: {
        container_class: {
            required: false,
            default: 'vx-col w-full'
        },
        disabled: {
            required: false,
            default: false
        },
        label: {
            required: false,
            default: null
        },
        label_class: {
            required: false,
            default: 'mb-3'
        },
        input_class: {
            required: false,
            default: 'mt-3 w-full'
        },
        model: {
            required: true
        },
        placeholder: {
            required: false,
            default: 'Type to Search..'
        },
        warning: {
            required: false,
            default: false
        },
        warning_text: {
            required: false,
            default: null
        },
        multiple: {
            default: false
        },
        endpoint: {
            required: true
        },
        list_length: {
            default: 20
        },
        label_keys: {
            required: true,
            default: () => ['id', ]
        },
        show_id_in_label: {
            default: false
        },
        load_initial: {
            default: false
        },
        use_id_as_value: {
            default: false
        },
        data_key: {
            required: false,
            default: null
        },
        close_on_select: {
            required: false,
            type: Boolean,
            default: true
        },
        use_cache: {
            required: false,
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            value: this.model,
            value_options: [],

            initialising: false
        }
    },
    mounted() {
        this.user = this.model
        if(this.load_initial)
            this.do_search(null, ()=>{}, true)
    },
    components: {
        vSelect,
    },
    watch: {
        model(newV, oldV) {
            if(newV == oldV) return
            if(!this.multiple) {
                if(this.use_id_as_value)
                    this.value = this.value_options.find(v => v.id == newV) || newV
                else
                    this.value = newV
            } else {
                if(this.use_id_as_value) {
                    let x = []
                    if(!newV) newV = []
                    newV.forEach(v2 => {
                        x.push(this.value_options.find(v => v.id == v2) || v2)
                    })
                }
                else
                    this.value = newV
            }
        },
        load_initial(newV, oldV) {
            if (newV == oldV) return
            else if (newV) this.do_search(null, (val) => {this.initialising = val}, true)
        },
        endpoint(newV) {
            this.do_search(null, (val) => {this.initialising = val}, true)
        }
    },
    methods: {
        updateModel() {
            if(this.value && this.use_id_as_value)
                if(!this.multiple)
                    this.$emit("update:model", this.value.id)
                else
                    this.$emit("update:model", this.value.map(v => v.id))
            else
                this.$emit("update:model", this.value)
            
            this.$emit('change')
        },
        async do_search(search, loading, skip_search=false){

            if(this.endpoint.split('?').at(-1).includes(null)) return

            let limit = this.list_length
            //support for offline
            let key = md5(this.endpoint)

            if(this.use_cache) {
                limit = 1000
            }

            let local_data = await this.$ionicStorage.get(key)
            // localStorage.getItem(key)

            if(local_data && this.use_cache) {
                try {
                    local_data = JSON.parse(local_data)
    
                    //checking cache is valid or not
                    let cache_on = local_data.cache_timestamp
                    if (cache_on < moment(new Date()).subtract(6, 'hours').toISOString()) {
                        //cache is invalid
                        await this.$ionicStorage.remove(key)
    
                    } else {
                        this.value_options = local_data.data
                        return
                    }

                } catch(err) {
                    await this.$ionicStorage.remove(key)
                }
            }

            let data = {
                limit: limit
            }
            if(!skip_search)
                data['search'] = search
            
            loading(true)
            let url = this.endpoint
            
            Request(this, 'GET', url, data).then( 
                async (res) => {
                    if(!this.data_key)
                        this.value_options = res.results
                    else
                        this.value_options = res.results[this.data_key]

                    // setting cache
                    await this.$ionicStorage.set(key, JSON.stringify({cache_timestamp: moment(new Date()).toISOString(), data: res.results}))

                    loading(false)
                }, (err) => {
                    this.$vs.notify({
                        time: 2500,
                        title: 'Error',
                        text: 'An Error Occured. Please Try Again',
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    })
                    this.value_options = []
                    loading(false)
                }
            )
            
        },
    }
}
</script>